 
import ApiService from './axios/Apiservices';

export const createInquiry = (data) => ApiService.post('/inquiry/store', data, {
  headers: { 'Content-Type': 'multipart/form-data' }
});

export const getInquiries = () => ApiService.get('/inquiry/list');

export const getInquiry = (id) => ApiService.get(`/inquiry/${id}`);

export const updateInquiry = (id, data) => ApiService.post(`/inquiry/update/${id}`, data, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const newsletters = (payload) => {
  return ApiService.post("/newsletter", payload);
};


export const deleteInquiry = (id) => ApiService.delete(`/inquiry/${id}`);